<template>
  <div>
    <v-container>
      <v-layout
        wrap
        align-center
      >
        <v-flex>
          <router-link to="/dashboard">
            <img 
              :height="imgHeight" 
              :src="logo" 
            />
          </router-link>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex
          text-md-right
        >
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      imgHeight: 128,
      logo: require('@/assets/svg/ELITE Logo.svg')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/profile/profileHeader.vue